{
  "version": "1.2.6",
  "objects": {
    "7431911414823304416": {
      "type": "frame",
      "id": "7431911414823304416",
      "z": 7246,
      "textContent": "",
      "left": 2777.2257791116067,
      "top": 339.40089080975383,
      "width": 400,
      "height": 500,
      "scaleX": 1.7891426161574897,
      "scaleY": 1.201211144067714,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 30,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7431911414812838754": {
      "type": "frame",
      "id": "7431911414812838754",
      "z": 4371,
      "textContent": "Frame 24",
      "left": 3150.0543023431046,
      "top": 359.40089080975383,
      "width": 400,
      "height": 500,
      "scaleX": 0.8070713080787449,
      "scaleY": 1.121211144067714,
      "fill": "#0073CF",
      "opacity": 0.05,
      "container": "7431911414823304416",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": "auto",
      "layoutPadding": 100,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7431911414822588584": {
      "type": "frame",
      "id": "7431911414822588584",
      "z": 4372,
      "textContent": "Frame 23",
      "left": 2797.2257791116067,
      "top": 359.40089080975383,
      "width": 400,
      "height": 500,
      "scaleX": 0.8070713080787449,
      "scaleY": 1.121211144067714,
      "fill": "transparent",
      "opacity": 1,
      "container": "7431911414823304416",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7431911414811738044": {
      "type": "frame",
      "id": "7431911414811738044",
      "z": 4370,
      "textContent": "Frame 46",
      "left": 2823.3497119443837,
      "top": 557.3956980797002,
      "width": 400,
      "height": 500,
      "scaleX": 0.6764516439148605,
      "scaleY": 0.44253520556109927,
      "fill": "transparent",
      "opacity": 1,
      "container": "7431911414822588584",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a4",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 20,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7431911414814769893": {
      "type": "wireframe",
      "id": "7431911414814769893",
      "z": 4374,
      "top": 557.3956980797002,
      "left": 2823.3497119443837,
      "width": 270.5806575659442,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414811738044",
      "layoutPosition": "a0",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#7E7B7B",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Email", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "Name",
        "iconLeft": { "prefix": "fas", "iconName": "user" },
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414820998482": {
      "type": "wireframe",
      "id": "7431911414820998482",
      "z": 4376,
      "top": 677.3956980797002,
      "left": 2823.3497119443837,
      "width": 270.12312697149355,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414811738044",
      "layoutPosition": "a1l",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#7E7B7B",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Subject",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414825387217": {
      "type": "wireframe",
      "id": "7431911414825387217",
      "z": 6107,
      "top": 617.3956980797002,
      "left": 2823.3497119443837,
      "width": 270.12312697149355,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911414811738044",
      "layoutPosition": "a1V",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#7E7B7B",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "Email",
        "iconLeft": { "prefix": "fas", "iconName": "envelope" },
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414814464543": {
      "type": "wireframe",
      "id": "7431911414814464543",
      "z": 6118,
      "top": 737.2550730797002,
      "left": 2823.3497119443837,
      "width": 260.0775259007052,
      "height": 39.859375,
      "scaleX": 1.0388579294218636,
      "scaleY": 1.0388579294218636,
      "container": "7431911414811738044",
      "layoutPosition": "a2",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#7E7B7B",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Message",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7431911414827685186": {
      "type": "frame",
      "id": "7431911414827685186",
      "z": 4380,
      "textContent": "Frame 46",
      "left": 2879.640040727356,
      "top": 495.3956980797002,
      "width": 400,
      "height": 500,
      "scaleX": 0.395,
      "scaleY": 0.084,
      "fill": "transparent",
      "opacity": 1,
      "container": "7431911414822588584",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7431911414821061401": {
      "type": "shape",
      "id": "7431911414821061401",
      "z": 4377,
      "shapeName": "text",
      "textContent": "<p>Contact us</p>",
      "left": 2879.640040727356,
      "top": 495.3956980797002,
      "width": 111.11290961314687,
      "height": 29.53634306172259,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.4219769831435092,
      "scaleY": 1.421976983143509,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "center",
      "fontSize": 19.90767776400913,
      "angle": 0,
      "container": "7431911414827685186",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "wrapText": true,
      "maskType": "none",
      "locked": false
    },
    "7431911414827989014": {
      "type": "frame",
      "id": "7431911414827989014",
      "z": 4381,
      "textContent": "Frame 45",
      "left": 2824.145796805733,
      "top": 798.6633008602498,
      "width": 400,
      "height": 500,
      "scaleX": 0.6724712196081134,
      "scaleY": 0.07526104227446286,
      "fill": "transparent",
      "opacity": 1,
      "container": "7431911414822588584",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a5",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 3,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7431911414827570543": {
      "type": "wireframe",
      "id": "7431911414827570543",
      "z": 4379,
      "top": 801.6633008602498,
      "left": 2827.145796805733,
      "width": 331.4063879045013,
      "height": 39.859375,
      "scaleX": 0.7935528627137647,
      "scaleY": 0.7935528627137646,
      "container": "7431911414827989014",
      "layoutPosition": "a4",
      "wireframeName": "button",
      "fill": "#0073CF",
      "textColor": null,
      "style": "roundFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Send message" },
      "setDimension": true
    },
    "7431911414818437413": {
      "type": "shape",
      "id": "7431911414818437413",
      "z": 6197,
      "shapeName": "icon",
      "textContent": "",
      "left": 2941.4989575154473,
      "top": 441.11353165588343,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.3428216642381676,
      "scaleY": 0.3428216642381676,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#0073CF",
      "angle": 0,
      "container": "7431911414822588584",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "maskType": "none",
      "iconName": "fas/comment",
      "locked": false
    }
  }
}
